import {
  ACTIVE_BUTTON_STYLE,
  ACCENT_BUTTON_STYLE,
  CANCEL_OPT_OUT_BUTTON_STYLE,
  BRAND,
  formatCurrency,
  capitalize,
  getStoredUser,
  buildReferralLink,
} from "../ui/theme";

export {
  ACTIVE_BUTTON_STYLE,
  ACCENT_BUTTON_STYLE,
  CANCEL_OPT_OUT_BUTTON_STYLE,
  BRAND,
  formatCurrency,
  capitalize,
  getStoredUser,
  buildReferralLink,
};

export const formatNumber = (value) => {
  const num = Number(value || 0);
  return num.toLocaleString("en-IN");
};

export const formatDateTime = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date);
};

export const formatDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value).slice(0, 10);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const getPaymentStatusBadge = (status) => {
  switch (String(status || "").toLowerCase()) {
    case "success":
    case "paid":
    case "completed":
    case "credit":
      return "success";
    case "pending":
      return "warning";
    case "failed":
    case "rejected":
      return "danger";
    case "refunded":
      return "secondary";
    default:
      return "secondary";
  }
};

export const getCourseStatusBadge = (status, optOut = false, isFinal = false) => {
  if (isFinal && optOut) return "danger";
  if (isFinal && !optOut) return "success";
  if (optOut) return "danger";
  switch (String(status || "").toLowerCase()) {
    case "success":
    case "active":
      return "success";
    case "pending":
      return "info";
    case "opted_out":
      return "danger";
    case "failed":
      return "danger";
    default:
      return "secondary";
  }
};

export const getCourseStatusLabel = (item) => {
  if (item?.is_final) {
    return item?.status_label || (item?.opt_out_status ? "Final: Opted Out" : "Final: Enrolled");
  }
  if (item?.opt_out_status) return "Opted Out";
  if (item?.status_label) return item.status_label;
  return capitalize(item?.status || "Enrolled");
};

export const getCommissionStatusBadge = (status) => {
  switch (String(status || "").toLowerCase()) {
    case "processed":
    case "success":
      return "success";
    case "pending":
      return "warning";
    case "blocked":
      return "danger";
    default:
      return "secondary";
  }
};

export const getWithdrawalStatusBadge = (status) => {
  switch (String(status || "").toLowerCase()) {
    case "approved":
    case "paid":
      return "success";
    case "pending":
      return "warning";
    case "rejected":
      return "danger";
    default:
      return "secondary";
  }
};

export const getRegistrationBadge = (status) => {
  switch (String(status || "").toLowerCase()) {
    case "active":
      return "success";
    case "inactive":
      return "warning";
    case "blocked":
      return "danger";
    default:
      return "secondary";
  }
};

export const getActivityBadge = (type) => {
  switch (String(type || "").toLowerCase()) {
    case "commission":
      return "success";
    case "course_purchase":
      return "info";
    case "withdrawal":
      return "warning";
    case "gift_bonus":
      return "primary";
    default:
      return "secondary";
  }
};
